/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useCallback, useState} from 'react'
import {useParams} from 'react-router-dom'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import axios from 'axios'
import Swal from 'sweetalert2'
import {useQueryClient} from 'react-query'
import {RelatedFiles, initialValues} from '../core/_models'
import {KTSVG} from '../../../../../../../../../_metronic/helpers'

export interface UseOption {
  readonly value: string
  readonly label: string
  readonly color: string
  readonly isFixed?: boolean
  readonly isDisabled?: boolean
}

type Props = {
  show: boolean
  handleClose: () => void
  id: string
  data: any
}
const relatedFilesSchema = Yup.object().shape({})
const API_URL = process.env.REACT_APP_API_URL || 'api'

const ModalAddRelatedFiles: React.FC<Props> = ({show, handleClose}) => {
  const intl = useIntl()
  const [loading, setLoading] = useState(false)
  const queryClient = useQueryClient()
  const {id} = useParams()

  //constante do modulo
  const moduloSting = 'Modules\\SGA\\Models\\Conditioning'

  //INICIO SUBMIT FORM
  const formik = useFormik<RelatedFiles>({
    initialValues,
    validationSchema: relatedFilesSchema,
    onSubmit: async (values) => {
      console.log('Adicionar', values)
      values.linkable_type = moduloSting
      values.linkable_id = parseInt(id || '0')

      setLoading(true)

      try {
        await axios.post(`${API_URL}/v1/links`, values)
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'RELATED_FILES.SWAL_ADD'}),
          showConfirmButton: false,
          timer: 2000,
        })
        queryClient.invalidateQueries('link-conditionings-list-page=1&items_per_page=10')
        formik.resetForm()
        handleClose()
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'RELATED_FILES.SWAL_ADD_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })
        setLoading(false)
        // formik.resetForm()
        // handleClose()
      }
    },
  })

  return (
    <Modal
      id={id}
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-600px h-auto'
      show={show}
      onHide={handleClose}
    >
      <div className='container-xxl p-5'>
        <div className='modal-header py-2 d-flex justify-align-content-between border-0'>
          {/* begin::Close */}
          <span className='fw-bold fs-4 '>
            Adicionar Link
            {/* {intl.formatMessage({id: 'COMMON.DOCUMENT_ADD'})} */}
          </span>
          <div className='btn btn-icon btn-sm btn-light-primary' onClick={handleClose}>
            <KTSVG className='svg-icon-2' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
          {/* end::Close */}
        </div>

        <div id='kt_account_profile_details' className='collapse show'>
          <form onSubmit={formik.handleSubmit} noValidate className='form'>
            <div className='card-body border-top p-4'>
              <div className='col-lg-12'>
                <div className='row'>
                  {/* Inicio da 1 linha */}
                  <div className='row mb-3'>
                    <label className='col-lg-12 col-form-label required fw-bold fs-6'>
                      {intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
                    </label>

                    <textarea
                      rows={2}
                      className='form-control form-control-lg form-control-solid'
                      title={intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
                      placeholder={intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
                      {...formik.getFieldProps('description')}
                    />
                  </div>
                  {/* fim da 1 linha */}

                  {/* Inicio da 1 linha */}
                  <div className='row mb-3'>
                    <label className='col-lg-12 col-form-label required fw-bold fs-6'>
                      URL <i className='fa-solid fa-link text-dark px-1'></i>
                      {/* {intl.formatMessage({id: 'COMMON.DESCRIPTION'})} */}
                    </label>

                    <input
                      placeholder='https://example.com'
                      pattern='https://.*'
                      required
                      className='form-control form-control-lg form-control-solid'
                      {...formik.getFieldProps('url')}
                    />
                  </div>
                  {/* fim da 1 linha */}

                  {/* Submit */}
                  <div className='d-flex justify-content-end py-6'>
                    <button type='submit' className='btn btn-primary' disabled={loading}>
                      {!loading && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                      {loading && (
                        <span className='indicator-progress' style={{display: 'block'}}>
                          {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}{' '}
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                    </button>
                  </div>
                </div>
                {/* ----------------------------------------------------------------------------------- */}
              </div>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}

export {ModalAddRelatedFiles}
